export const ADVANTAGES_LIST: string[] = [
	'Надати документи через Дію',
	'Підтвердити свою особу',
	'Заповнити анкету',
	'Підписати документи',
];
